module.exports = __webpack_public_path__ + "static/media/tumblingphoto.fead2340.jpg";